/**
 * ¿Se ofrece el seguro de entradas en el proceso de compra?
 *
 * El evento 19951 no lo ofrece, aunque el teatro tenga el seguro activo: fue una
 * petición puntual y se mantiene.
 */

export const EVENTO_SIN_SEGURO = 19951;

/**
 * @param {object} opciones
 * @param {number|string} [opciones.eventId] id del evento
 * @param {object} [opciones.teatro] teatro con `seguro_entradas_activo`
 * @param {string} [opciones.tipoDocumento] tipo de documento elegido
 * @returns {boolean}
 */
export function ofrecerSeguroEntradas({ eventId, teatro, tipoDocumento } = {}) {
    if (Number(eventId) === EVENTO_SIN_SEGURO) {
        return false;
    }

    return Boolean(teatro?.seguro_entradas_activo) && tipoDocumento !== 'OTROS';
}
